/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetListResponse
 */
export interface GetListResponse {
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    revokedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    issuee?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    issueeAid?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    issuer?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    issuerAid?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    alias?: string;
    /**
     * 
     * @type {string}
     * @memberof GetListResponse
     */
    schemaSaid?: string;
}

/**
 * Check if a given object implements the GetListResponse interface.
 */
export function instanceOfGetListResponse(value: object): boolean {
    return true;
}

export function GetListResponseFromJSON(json: any): GetListResponse {
    return GetListResponseFromJSONTyped(json, false);
}

export function GetListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'issuee': json['issuee'] == null ? undefined : json['issuee'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issuer': json['issuer'] == null ? undefined : json['issuer'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'alias': json['alias'] == null ? undefined : json['alias'],
        'schemaSaid': json['schemaSaid'] == null ? undefined : json['schemaSaid'],
    };
}

export function GetListResponseToJSON(value?: GetListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'revokedAt': value['revokedAt'],
        'issuee': value['issuee'],
        'issueeAid': value['issueeAid'],
        'issuer': value['issuer'],
        'issuerAid': value['issuerAid'],
        'alias': value['alias'],
        'schemaSaid': value['schemaSaid'],
    };
}

